/* REQUISICÕES AJAX */
export const INICIOU_REQUISICAO_WEB = 'INICIOU_REQUISICAO_WEB';
export const FINALIZOU_REQUISICAO_WEB = 'FINALIZOU_REQUISICAO_WEB';
export const OBTEVE_SORTEADOS = 'OBTEVE_SORTEADOS';
export const REMOVEU_SORTEADOS = 'REMOVEU_SORTEADOS';